import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from './router';
import { App } from './App';
import { initAppearance } from './core/appearance';
import { isDesktopUA } from './desktop/detect';
import './styles.css';
import './desktop/chrome.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

// The theme was settled by public/theme-init.js before the first paint; this keeps it following the
// system and other tabs.
initAppearance();
if (isDesktopUA()) document.documentElement.dataset.officeDesktop = '';

// Inside the desktop app, the page finds the shell and tells it the theme (docs/desktop-bridge.md).
if (isDesktopUA()) void import('./desktop/cloud').then((m) => m.attachCloud());

// Straight to the first render: nothing is awaited. The design system's old
// component bundle used to be fetched and run before anything painted; the app draws
// its own controls now (core/controls.tsx), so the first paint is the app's.
createRoot(container).render(
  <React.StrictMode>
    <RouterProvider>
      <App />
    </RouterProvider>
  </React.StrictMode>
);
